/**
 * The `width`/`height` attributes for a CMS image, so the browser reserves its
 * box before the file arrives instead of growing it on load and pushing the
 * content under it down (CLS). CSS still decides the rendered size; the
 * attributes only give the box its aspect ratio.
 *
 * Both or neither: Umbraco reports 0 for media it cannot measure (SVG), and a
 * 0 attribute would collapse the image instead of sizing it.
 */
export function imageSizeAttributes(
  image: { width?: number | null; height?: number | null } | null | undefined
): { width?: number; height?: number } {
  const width = image?.width ?? 0;
  const height = image?.height ?? 0;
  return width > 0 && height > 0 ? { width, height } : {};
}
